import PenWhite from "../assets/images/pen-tool-white.svg";
import GridWhite from "../assets/images/grid-white.svg";
import { useNavigate } from "react-router-dom";
import moment from "moment";

export const DraftBookCard = ({
  _id,
  title = "Semillas Elementary Spanish 1",
  updatedAt = "04/18/24",
}) => {
  const navigate = useNavigate();
  return (
    <div className="book_shelf_draft_card">
      <div className="d-flex flex-column content" style={{ gap: "20px" }}>
        <h3 className="book_shelf_draft_card_title">
          {title.length > 15 ? title?.slice(0, 15) + "..." : title}
        </h3>
        <h4 className="book_shelf_draft_card_footer">{`Last edited ${new moment(
          updatedAt
        ).format("MM/DD/YY")}`}</h4>
      </div>
      <div className="hover_overlay zIndex-999">
        <div
          className="d-flex cursor"
          onClick={() => navigate(`/dashboard/bookshelf/overview/${_id}`)}
        >
          <img src={GridWhite} alt="grid-white" width={25} height={25} />
          <h3 className="hover_title">Book Overview</h3>
        </div>
        <div
          className="d-flex cursor"
          onClick={() => navigate(`/create/${_id}`)}
        >
          <img src={PenWhite} alt="pen-tool-white" width={25} height={25} />
          <h3 className="hover_footer">Edit in Create</h3>
        </div>
      </div>
    </div>
  );
};
